import React from 'react';
import { Col } from 'reactstrap';
import { subscribe } from 'react-contextual';
import MediaQuery from 'react-responsive';

const ImageCard = ({
	src, alt, style, className, link, clickHandler
}) => (
	<React.Fragment>
		<MediaQuery query="(max-width: 576px)">
			<Col style={style.mobile} className={className}>
				<a href={link} onClick={clickHandler} >
				<img className="w-100 h-100 generic-image-card align-self-center" src={src.mobile} alt={alt} />
				</a>
			</Col>
		</MediaQuery>
		<MediaQuery query="(min-width: 576px)">
			<Col style={style.desktop} className={className}>
				<a href={link} onClick={clickHandler} >
				<img className="w-100 h-100 generic-image-card align-self-center" src={src.desktop} alt={alt} />
				</a>
			</Col>
		</MediaQuery>
	</React.Fragment>

);

export default subscribe()(ImageCard);
